if (!customElements.get('sp-ritual-builder')) {
  customElements.define(
    'sp-ritual-builder',
    class extends HTMLElement {
      connectedCallback() {
        this.toggles = [...this.querySelectorAll('.sp-ritual__toggle')];
        this.totalEl = this.querySelector('[data-ritual-total]');
        this.wasEl = this.querySelector('[data-ritual-was]');
        this.saveEl = this.querySelector('[data-ritual-save]');
        this.countEl = this.querySelector('[data-ritual-count]');
        this.addBtn = this.querySelector('[data-ritual-add]');
        this.toggles.forEach((t) =>
          t.addEventListener('change', () => this.update())
        );
        if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());
        this.update();
      }

      selected() {
        return this.toggles.filter((t) => t.checked);
      }

      money(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
      }

      update() {
        const sel = this.selected();
        // Rabat 2+1: co trzecia butelka (licząc od najtańszej) jest gratis.
        // Liczymy go tutaj, żeby klient widział cenę po rabacie od razu, a nie dopiero w koszyku.
        const prices = sel
          .map((t) => parseInt(t.dataset.price || '0', 10))
          .sort((a, b) => a - b);
        const total = prices.reduce((s, p) => s + p, 0);
        const freeCount = Math.floor(prices.length / 3);
        const discount = prices.slice(0, freeCount).reduce((s, p) => s + p, 0);
        const payable = total - discount;
        this.toggles.forEach((t) => {
          const card =
            t.closest('.sp-ritual__card') || t.closest('.sp-picker__card');
          card?.classList.toggle('is-on', t.checked);
        });
        if (this.totalEl) this.totalEl.textContent = this.money(payable);
        if (this.wasEl) {
          this.wasEl.textContent = this.money(total);
          this.wasEl.hidden = discount === 0;
        }
        if (this.saveEl) {
          this.saveEl.textContent = 'oszczędzasz ' + this.money(discount);
          this.saveEl.hidden = discount === 0;
        }
        const require = parseInt(this.dataset.require || '0', 10);
        if (this.countEl) {
          const n = sel.length;
          if (require) {
            this.countEl.textContent = 'wybrano ' + n + ' / ' + require;
          } else {
            const word = n === 1 ? 'macerat' : n >= 2 && n <= 4 ? 'maceraty' : 'maceratów';
            this.countEl.textContent = n + ' ' + word;
          }
        }
        if (this.addBtn)
          this.addBtn.disabled = require ? sel.length !== require : sel.length === 0;
      }

      add() {
        const items = this.selected().map((t) => ({
          id: parseInt(t.dataset.variant, 10),
          quantity: 1,
        }));
        if (!items.length) return;
        this.addBtn.disabled = true;
        const original = this.addBtn.textContent;
        this.addBtn.textContent = 'Dodaję…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((r) => r.json())
          .then(() => {
            window.location = '/cart';
          })
          .catch(() => {
            this.addBtn.disabled = false;
            this.addBtn.textContent = original;
          });
      }
    }
  );
}
